import React, { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import TitleBox from '../../components/common/breadcrumbs/TitleBox';
import DetailTemplate from '../../components/common/template/DetailTemplate';
import EmployeeTemplate from '../../components/employeemng/EmployeeTemplate';

import { unloadEmployee, viewEmployee } from '../../modules/empModule/employee';
import EmployeeInfoContainer from './EmployeeInfoContainer';
import NpTabsContainer from './np/NpTabsContainer';
import PersonalTabsContainer from './personal/PersonalTabsContainer';
import ResultTabsContainer from './result/ResultTabsContainer';
import ResumeTabsContainer from './resume/ResumeTabsContainer';
import * as empApi from '../../lib/api/employee';
import { useBoolean } from '../../hooks/useBoolean';
import AskDialog from '../../components/common/dialog/AskDialog';
import TempPasswordDialog from '../../components/common/dialog/TempPasswordDialog';
import { useIsAdmin } from '../../hooks/useIsAdmin';

const EmployeeContainer = () => {
  let navigate = useNavigate();
  const { id } = useParams();
  const { enqueueSnackbar } = useSnackbar();

  // 수정/퇴사처리/비밀번호초기화는 서버가 관리자만 허용한다(UserController) - 비관리자는
  // 버튼을 숨긴다. 실제 차단은 서버가 한다. 보안 배치 2(권한, 2026-10-27).
  const isAdmin = useIsAdmin();

  const [titleData, setTitleData] = useState(null);
  const [visible, setVisible] = useState(false);
  const confirm = useBoolean();
  const tempPwdDialog = useBoolean();
  const [tempPassword, setTempPassword] = useState('');

  //처음 마운트 될 때 partenr 데이터 요청
  const dispatch = useDispatch();
  const { employee, error, loading } = useSelector(
    ({ empModule, loading }) => ({
      employee: empModule.employee.employee,
      error: empModule.employee.error,
      loading: loading['employee/VIEW_EMPLOYEE'],
    }),
  );

  useEffect(() => {
    dispatch(viewEmployee(id));

    //언마운트될때 리덕스에서 파트너 데이터 초기화
    return () => {
      dispatch(unloadEmployee());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (employee) {
      let title = {
        name:
          '[' + employee.usrNo + '] ' + employee.usrNm + ' ' + employee.gradeNm,
        no: employee.usrNo,
      };
      setTitleData(title);
    }
  }, [employee]);

  const handleGoBack = () => {
    navigate('/employeemng');
  };
  const handleEdit = () => {
    navigate(`/employeemng/${id}/edit`);
  };

  const handleDelete = () => {
    setVisible(true);
  };

  const onCancle = () => {
    setVisible(false);
  };

  const onConfirm = () => {
    setVisible(false);
    onRemove();
  };

  const onRemove = async () => {
    try {
      const res = await empApi.removeEmployee(id);

      if (res.data.info) {
        //  console.log(res.data.info, 'user');
        handleGoBack();
        enqueueSnackbar('미사용 처리 성공', {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  const onInitPwd = async () => {
    try {
      const res = await empApi.initEmpPwd(id);

      if (res.data.result) {
        confirm.onFalse();
        setTempPassword(res.data.tempPassword || '');
        tempPwdDialog.onTrue();
        enqueueSnackbar('비밀번호 초기화 처리 성공', {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  return (
    <EmployeeTemplate employee={employee} loading={loading} error={error}>
      <TitleBox
        edit={isAdmin}
        remove={isAdmin}
        isInitPwd={isAdmin}
        editDelText="미사용"
        handleGoBack={handleGoBack}
        menuName="인사 관리/사원 관리/상세보기"
        menuLink="/employeemng"
        icon="user"
        titleData={titleData}
        handleEdit={handleEdit}
        handleRemove={handleDelete}
        handleInitPwd={confirm.onTrue}
      />
      <DetailTemplate title="기본사항">
        <EmployeeInfoContainer employee={employee} />
      </DetailTemplate>
      <DetailTemplate title="이력사항">
        <ResumeTabsContainer />
      </DetailTemplate>
      {/* <DetailTemplate title="성과관리">
        <ResultTabsContainer />
      </DetailTemplate> */}
      <DetailTemplate title="개인상세 정보">
        <PersonalTabsContainer />
      </DetailTemplate>
      {/* <DetailTemplate title="국책과제 참여 현황">
        <NpTabsContainer />
      </DetailTemplate> */}
      <AskDialog
        visible={visible}
        title="사원 미사용"
        description="선택한 사원을 미사용 처리하시겠습니까?"
        confirmText="미사용"
        onConfirm={onConfirm}
        onCancle={onCancle}
      />
      <AskDialog
        visible={confirm.value}
        title="사원 비밀번호 초기화"
        description={`랜덤 임시 비밀번호가 발급되며, 이 사원의 모든 로그인 세션이 종료됩니다.\n발급된 임시 비밀번호는 다음 화면에서 한 번만 확인할 수 있습니다.`}
        confirmText="초기화"
        onConfirm={onInitPwd}
        onCancle={confirm.onFalse}
      />
      <TempPasswordDialog
        visible={tempPwdDialog.value}
        tempPassword={tempPassword}
        onClose={() => {
          tempPwdDialog.onFalse();
          setTempPassword('');
        }}
      />
    </EmployeeTemplate>
  );
};

export default EmployeeContainer;
